module.exports = __webpack_public_path__ + "img/组 2.3e6eddb0.png";